import { useEffect, useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import api from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { CalendarRange, Clock, MapPin } from "lucide-react";

export default function FacultySchedulePage() {
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    api.get("/v2/events?limit=20").then((r) => {
      setEvents(r.data.items || []);
      if (r.data.items?.[0]) setEventId(r.data.items[0].id);
    });
  }, []);

  useEffect(() => {
    if (!eventId) return;
    api.get(`/v2/schedules?event_id=${eventId}`).then((r) => setSchedules(r.data.items || []));
  }, [eventId]);

  return (
    <DashboardLayout>
      <div className="max-w-5xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">
              Itinerary
            </p>
            <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tighter text-[#0A192F]">
              Conference schedule
            </h1>
          </div>
          <Select value={eventId} onValueChange={setEventId}>
            <SelectTrigger className="w-[320px] h-11" data-testid="schedule-event-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {events.map((e) => <SelectItem key={e.id} value={e.id}>{e.title}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        <div className="mt-10 space-y-8">
          {schedules.map((s) => (
            <div key={s.id} className="relative" data-testid={`schedule-${s.date}`}>
              <div className="flex items-center gap-3 mb-5">
                <div className="h-9 w-9 rounded-md bg-[#0A192F] text-[#D4AF37] flex items-center justify-center">
                  <CalendarRange className="h-4 w-4" />
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-bold">
                    Day schedule
                  </p>
                  <h2 className="text-xl font-semibold tracking-tight text-[#0A192F]">
                    {new Date(s.date).toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}
                  </h2>
                </div>
              </div>
              <div className="relative ml-4 border-l-2 border-slate-200 pl-6 space-y-4">
                {(s.items || []).map((it, i) => (
                  <div key={i} className="relative">
                    <span className="absolute -left-[34px] top-1 h-3 w-3 rounded-full bg-[#D4AF37] border-2 border-white" />
                    <div className="rounded-lg bg-white border border-slate-200 p-4 flex items-center justify-between flex-wrap gap-3" data-testid={`schedule-item-${i}`}>
                      <div>
                        <div className="flex items-center gap-3 text-xs text-slate-500">
                          <Clock className="h-3.5 w-3.5" /> {it.time}
                          {it.room_id && (<><MapPin className="h-3.5 w-3.5 ml-3" /> {it.room_id}</>)}
                        </div>
                        <p className="mt-1 font-semibold text-[#0A192F]">{it.title}</p>
                        {it.description && <p className="text-xs text-slate-500 mt-1">{it.description}</p>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          {schedules.length === 0 && (
            <div className="rounded-xl border-2 border-dashed border-slate-200 p-10 text-center">
              <p className="text-sm text-slate-500">No schedule published for this event yet.</p>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
